import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input()
  logged

  is_loggedin = false;

  constructor(private _authService : AuthService) { }

  ngOnInit(): void {
    if(this.logged){
      this.is_loggedin = true;
    }else{
      this._authService.loggedIn().subscribe(data=>{
        if(data != 'invalid'){
          this.is_loggedin = true;
        }else{
          this.is_loggedin = false;
        }
      });
    }

  }


  logout(){
    this._authService.logoutUser();
    this.is_loggedin = false;
  }

}
